'use strict';

import decoded from 'decoded';

export const homeCards = {
    0: { id: 0, section: 'main',
         icon: 'home',
         title: '',
         description: '',
         media: '',
         link: '/' },

    1: { id: 1, section: 'main',
         icon: 'phone',
         title: 'Contato',
         description: '(11) 4398-7300',
         media: '',
         link: '' },

    2: { id: 2, section: 'main',
         icon: '',
         title: 'Produtos e Serviços',
         description: 'A Accede possui hoje uma variedade de produtos e serviços, entre eles, Células Robotizadas, Bancadas e máquinas de montagens e testes, Software e start-up para CTL, IHM, CNC e supervisórios. Concheça todos',
         media: '',
         link: '/products',
         bg: '#0B9FF0',
         fg: '#ffffff' },

    3: { id: 3, section: 'main',
         icon: 'star-o',
         title: '',
         description: 'Excelência em automação industrial',
         media: '/media/pictures/maq2.jpg',
         link: '' },

    4: { id: 4, section: 'main',
         icon: 'building-o',
         title: 'Institucional',
         description: 'Conheça nossa história, nossos objetivos, missão, valores e mercado',
         media: '',
         link: '/about' },

    5: { id: 5, section: 'main',
         icon: 'user-tie',
         title: 'Clientes',
         description: 'Nossos clientes sempre em 1º lugar. Conheça nossos casos de sucesso',
         media: '',
         link: '/cases' },

    7: { id: 7, section: 'main',
         icon: 'pin_drop',
         title: 'Localização',
         description: 'Clique para conhecer os detalhes da nossa localização',
         media: '',
         link: 'place_id:ChIJYfPkiaNDzpQRBzb45roL1TQ',
         trigger: 'overlay:location' },

    10: { id: 10, section: 'main' }

}



// WEBPACK FOOTER //
// ./app/pages/home.js